import { HIDE_ADDPRACTICE_MODAL, SHOW_ADDPRACTICE_MODAL } from '../../../common/constants/reduxConstants'

export const showAddPracticeModal = () => {
  return { type: SHOW_ADDPRACTICE_MODAL }
}
export const hideAddPracticeModal = () => {
  return { type: HIDE_ADDPRACTICE_MODAL }
}
